import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Alert, Button, Grid, IconButton, TextField } from "@mui/material";
import { Field, Form, Formik } from "formik";
import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
//import AlertInfoComponent from "shared-components/src/components/feedback/AlertInfo.component";
import CircularProgressComponent from "shared-components/src/components/feedback/CircularProgress.component";
import * as Yup from "yup";
import { signupRequest } from "../../store/actions/signup.actions";

const SignupComponent = (props) => {
  const { logo } = props;
  const [showPassword, setShowPassword] = useState(false);
  const error = useSelector((state) => state.signup.error);
  const alreadyRegistered = useSelector(
    (state) => state.signup.alreadyRegistered
  );
  const success = useSelector((state) => state.signup.success);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleSignup = (value) => {
    value = { ...value, username: value.email };
    dispatch(signupRequest(value));
  };

  const initialValues = {
    name: "",
    surname: "",
    email: "",
    password: "",
    confirm_password: "",
  };

  const errorMessages = {
    required: t("signup_page.required"),
    emailInvalid: t("signup_page.emailInvalid"),
    passwordMismatch: t("signup_page.passwordMismatch"),
    passwordMin: t("signup_page.passwordMin"),
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(errorMessages.required),
    surname: Yup.string().required(errorMessages.required),
    email: Yup.string()
      .email(errorMessages.emailInvalid)
      .required(errorMessages.required),
    password: Yup.string()
      .min(8, errorMessages.passwordMin)
      .required(errorMessages.required),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("password"), null], errorMessages.passwordMismatch)
      .required(errorMessages.required),
  });

  const alreadyRegisteredInWater = (alreadyRegistered) => {
    return alreadyRegistered?.active_platform === "water";
  };

  return (
    <Fragment>
      {/* <AlertInfoComponent /> */}
      <CircularProgressComponent />
      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          {logo && <img src={logo} style={{ maxWidth: "inherit" }} alt="" />}
          <h4>{t("signup_page.signup")}</h4>
          <h5>{t("signup_page.signup_subtitle")}</h5>
        </Grid>

        <Grid item xs={12}>
          {error && (
            <Alert severity="error" style={{ marginBottom: "16px" }}>
              {t(`signup_page.errors.${error}`)}
            </Alert>
          )}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSignup}
          >
            {({ errors, touched }) => (
              <Form>
                <Grid container rowSpacing={2} columnSpacing={2} style={{}}>
                  <Grid item xs={12}>
                    <Field
                      as={TextField}
                      label={t("signup_page.name")}
                      name={`name`}
                      variant="outlined"
                      fullWidth
                      error={errors.name && touched.name}
                      helperText={errors.name}
                      disabled={success}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      as={TextField}
                      label={t("signup_page.surname")}
                      name={`surname`}
                      variant="outlined"
                      fullWidth
                      disabled={success}
                      error={errors.surname && touched.surname}
                      helperText={errors.surname}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      as={TextField}
                      label={t("signup_page.email")}
                      name={`email`}
                      variant="outlined"
                      fullWidth
                      disabled={success}
                      error={errors.email && touched.email}
                      helperText={errors.email}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      type={showPassword ? "text" : "password"}
                      as={TextField}
                      label={t("signup_page.password")}
                      name={`password`}
                      variant="outlined"
                      fullWidth
                      disabled={success}
                      error={errors.password && touched.password}
                      helperText={errors.password}
                      InputProps={{
                        endAdornment: (
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      type={showPassword ? "text" : "password"}
                      as={TextField}
                      label={t("signup_page.confirm_password")}
                      name={`confirm_password`}
                      variant="outlined"
                      fullWidth
                      disabled={success}
                      error={
                        errors.confirm_password && touched.confirm_password
                      }
                      helperText={errors.confirm_password}
                      InputProps={{
                        endAdornment: (
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      as={TextField}
                      label={t("signup_page.company_name")}
                      name={`companyName`}
                      variant="outlined"
                      fullWidth
                      disabled={success}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    {success ||
                    (alreadyRegisteredInWater(alreadyRegistered) &&
                      error) ? null : (
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                      >
                        {t("signup_page.signup")}
                      </Button>
                    )}
                    {success ? (
                      <Alert
                        severity="success"
                        style={{ marginBottom: "16px" }}
                      >
                        {t("signup_page.signup_success")}
                      </Alert>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    {alreadyRegisteredInWater(alreadyRegistered) && error ? (
                      <span>
                        {/* <Button variant="outlined" color="primary" fullWidth>
                          {t("signup_page.require_access")}
                        </Button> */}
                        <Alert
                          severity="success"
                          style={{ marginBottom: "16px" }}
                        >
                          {t("signup_page.require_access_text")}
                        </Alert>
                      </span>
                    ) : null}
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default SignupComponent;
